export const ValidationInformationResult = ({ reportData }) => {
  const renderValidationMessage = () => {
    const { VALID, VALIDATION_RESULT, VALIDATION_COMPLETE, VALIDATION_DATE } = reportData;
    const validStatus = +VALID;

    switch (validStatus) {
      case 0:
        return <p>No match</p>;
      case 1:
        if (VALIDATION_COMPLETE === 'false' && VALIDATION_DATE) {
          return <p className="text-[red]">Verification process started but did not complete</p>;
        }
        if (VALIDATION_RESULT === 'full match') {
          return <p className="flex items-center">Full match</p>;
        }
        if (VALIDATION_RESULT === 'partial match') {
          return <p>Partial match</p>;
        }
        break;
      case 2:
        if (VALIDATION_COMPLETE === 'false' && VALIDATION_DATE) {
          return <p className="text-[red]">Verification process started but did not complete</p>;
        } else {
          return <p>Not Verified</p>;
        }
      default:
        return null;
    }
  };

  return <>{renderValidationMessage()}</>;
};
